import { type TAssignee } from 'features/assignee/types';
import { type PROPOSAL_TYPE } from 'features/proposal/types';

export enum E_OFFICE_MANAGEMENT_TYPE {
  APPROVAL_TEMPLATE = 'approval-template',
  ADMIN_TYPE = 'admin-type',
  CONTENT_TEMPLATE = 'content-template',
}

export type TContentTemplateDetail = {
  key: string | null;
  content: string;
};

export type TUpdateContentTemplatePayload = {
  proposalType: PROPOSAL_TYPE;
  content: string;
};

export type TApprovalLevelFormItem = {
  _localId: string;
  code: string | null;
  name: string;
  allow_edit: boolean;
  username: string | null;
  assignee: TAssignee | null;
};

export type TApprovalLevelPayload = {
  code?: string | null;
  level: number;
  name: string;
  allow_edit: boolean;
  username?: string | null;
  is_deleted: boolean;
};
